import { createContext, useContext } from 'react';

export const AgreementContext = createContext({ agreed: false });
export const useAgreement = () => useContext(AgreementContext); 